import React from 'react';

const Cover = ({ cover, likeBackground }) => (
  <React.Fragment>
      {(function() {
        switch (likeBackground) {
          case false:
            return (
              <div className="loginrightw">
                <div
                  className="rightinner"
                  style={{
                    background: `url(${cover}) no-repeat center center`,
                    backgroundSize: 'cover' }}
                />
              </div>
            );
          default:
            return (
              <img src={cover} className="login2_bg_img" />
            );
        }
      })()}
  </React.Fragment>
);

Cover.propTypes = {
};

export default Cover;



// WEBPACK FOOTER //
// ./src/components/login/cover/Cover.jsx